import { useAuthenticatedFirebaseUser } from '@/auth/useFirebaseUser'
import { useAgentSupportRequests, useSupportAgentAlerts } from '@/state/support/useAgentSupportRequests'

const AgentAlerts = () => {
  const { requests, loadState } = useAgentSupportRequests()
  useSupportAgentAlerts(requests, { isLoaded: loadState === 'ready' })
  return null
}

export const SupportAgentAlerts = () => {
  const { supportRole } = useAuthenticatedFirebaseUser()
  return supportRole === null ? null : <AgentAlerts />
}
